import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = COMMON_EVENT_NAMES.NAVIGATED;
